// extracted by mini-css-extract-plugin
export default {"wrapper":"RoundedButtonGroup_wrapper__M4r2z","likeAnimation":"RoundedButtonGroup_likeAnimation__CzvB3"};